export const FIRM_BRANDING_DEFAULT_COLOR = '#3176b2';
